import { useEffect, useState } from 'react';
import { USDollar, USD_TO_CNY } from 'utils/format';

export function FundSubtypeTableView(props) {
    const { type, investments, sumMethod } = props;
    const [subtypeSet, setSubtypeSet] = useState(new Set());

    useEffect(() => {
        var tmpSubtypeSet = new Set();
        for (const investment of investments) {
            if (!investment.subtype) continue;
            tmpSubtypeSet.add(investment.subtype);
        }
        setSubtypeSet(tmpSubtypeSet);
    }, []);

    const positionOfNoSubtype = investments.filter(
        (investment) => !investment.subtype
    );

    function Subtype(props) {
        const { subtype, id } = props;
        const positionOfCurSubtype = investments.filter(
            (investment) =>
                investment.subtype &&
                investment.subtype.toLowerCase() === subtype.toLowerCase()
        );
        return (
            <div
                key={id}
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    border: '1px solid black',
                    borderTop: '0px',
                    width: '870px',
                }}
            >
                <div style={{ width: '240px', textAlign: 'center' }}>
                    {subtype}
                </div>

                <div style={{ width: '180px', textAlign: 'center' }}>
                    {sumMethod(positionOfCurSubtype, 'amount')}
                </div>

                <div style={{ width: '150px', textAlign: 'center' }}>
                    {sumMethod(positionOfCurSubtype, 'account_balance')}
                </div>

                <div style={{ width: '150px', textAlign: 'center' }}>
                    {sumMethod(positionOfCurSubtype, 'interest_received')}
                </div>

                <div style={{ width: '150px', textAlign: 'center' }}>
                    {sumMethod(positionOfCurSubtype, 'principal_returned')}
                </div>
            </div>
        );
    }

    return (
        <>
            <div>{type}</div>

            <div
                style={{
                    overflowX: 'scroll',
                    overflow: 'auto',
                    scrollbarWidth: 'auto',
                }}
            >
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        fontSize: '17px',
                        width: '870px',
                        borderBottom: '1px solid black',
                    }}
                >
                    <div style={{ width: '240px', textAlign: 'center' }}>
                        {'Subtype'}
                    </div>

                    <div style={{ width: '180px', textAlign: 'center' }}>
                        Commitment Number
                    </div>

                    <div style={{ width: '150px', textAlign: 'center' }}>
                        Equity Balance
                    </div>

                    <div style={{ width: '150px', textAlign: 'center' }}>
                        Distribute Interest
                    </div>

                    <div style={{ width: '150px', textAlign: 'center' }}>
                        Principal Return
                    </div>
                </div>

                {[...subtypeSet].map((subtype, id) => (
                    <Subtype key={id} id={id} subtype={subtype} />
                ))}

                {investments.filter((investment) => !investment.subtype)
                    .length > 0 && (
                    <div
                        style={{
                            display: 'flex',
                            flexDirection: 'row',
                            border: '1px solid black',
                            borderTop: '0px',
                            width: '870px',
                        }}
                    >
                        <div style={{ width: '240px', textAlign: 'center' }}>
                            {'Others'}
                        </div>

                        <div style={{ width: '180px', textAlign: 'center' }}>
                            {sumMethod(positionOfNoSubtype, 'amount')}
                        </div>

                        <div style={{ width: '150px', textAlign: 'center' }}>
                            {sumMethod(positionOfNoSubtype, 'account_balance')}
                        </div>

                        <div style={{ width: '150px', textAlign: 'center' }}>
                            {sumMethod(
                                positionOfNoSubtype,
                                'interest_received'
                            )}
                        </div>

                        <div style={{ width: '150px', textAlign: 'center' }}>
                            {sumMethod(
                                positionOfNoSubtype,
                                'principal_returned'
                            )}
                        </div>
                    </div>
                )}

                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        border: '1px solid black',
                        borderTop: '0px',
                        width: '870px',
                    }}
                >
                    <div style={{ width: '240px', textAlign: 'center' }}>
                        {'Sum'}
                    </div>

                    <div style={{ width: '180px', textAlign: 'center' }}>
                        {sumMethod(investments, 'amount')}
                    </div>

                    <div style={{ width: '150px', textAlign: 'center' }}>
                        {sumMethod(investments, 'account_balance')}
                    </div>

                    <div style={{ width: '150px', textAlign: 'center' }}>
                        {sumMethod(investments, 'interest_received')}
                    </div>

                    <div style={{ width: '150px', textAlign: 'center' }}>
                        {sumMethod(investments, 'principal_returned')}
                    </div>
                </div>
            </div>
        </>
    );
}
